export default __webpack_public_path__ + "static/media/tehdas_alkukokoonpano_360.713aae49.jpg";